import { UserService } from './../../../../../../../services/user/user.service';
import { KpiService } from 'src/app/services/kpi/kpi.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-user',
  templateUrl: './card-user.component.html',
  styleUrls: ['./card-user.component.scss'],
})
export class CardUserComponent implements OnInit {
  @Input() isList :boolean
  image = `https://cdn2.excelsior.com.mx/media/inside-the-note/pictures/2020/06/03/edwin.jpg`
  image2 = `https://img.freepik.com/vector-premium/avatar-perfil-usuario-femenino-es-mujer-personaje-protector-pantalla-emociones_505620-617.jpg?w=2000`
  @Input() user
  constructor(private userService : UserService) { }

  async ngOnInit() {
    const image =  await this.userService.GetImageProfileUser();
    this.user.image = image ? image : '../../../../../../../../assets/img/default-user.jpg'
  }
  
}
